import { formatUSD } from '../../helpers';
import AnalyticsSmallCard from './AnalyticsSmallCard';
// import useAnalytics from '../../hooks/analytics/useAnalytics';
import useMockAnalytics from '../../hooks/analytics/useMockAnalytics';

const OpenInterest = () => {
    const { analytics, isLoading, defaultData } = useMockAnalytics();

    return (
        <AnalyticsSmallCard
            title='Open Interest'
            percentageDifference={
                analytics ? analytics.openInterests.dailyDiffPercentage.toString() : '0'
            }
            amount={formatUSD(analytics?.openInterests.currentValue.toString() || '0', {
                maxDecimals: 0,
            })}
            data={analytics?.openInterests.historicalData ?? defaultData}
            isLoading={isLoading}
        />
    );
};

export default OpenInterest;
